import { genericThunkCreator2 } from 'app/actions/genericActionCreator'

export const getCountyLoanLimits = () => genericThunkCreator2('COUNTY_LOAN_LIMITS', `/lgyhub/api/guaranty-calculator/countyloanlimits`)

export const estimateGuaranty = (guarantyEstimateRequest) => genericThunkCreator2('ESTIMATE', `/lgyhub/api/guaranty-calculator/estimate`, { method: 'POST', body: guarantyEstimateRequest })

